/* eslint-disable no-unused-vars */
/** @module Auth0PreLoginHandlerMfaChoice */
/* eslint-disable import/extensions */
import Auth0PreLoginHandlerBase from '../auth0-pre-login-handler-base.mst.mjs';
import Auth0MfaChoicePageHelper from '../../../pages/auth0-mfa-choice-page-helper.mst.mjs';

class Auth0PreLoginHandlerMfaChoice extends Auth0PreLoginHandlerBase {
  _shouldHandleSync = () => {
    return this._qs.get('mfa') === 'choice';
  };

  /**
   * @inheritdoc
   */
  async shouldHandle() {
    return Promise.resolve(this._shouldHandleSync());
  }

  /**
   * @inheritdoc
   */
  async run(viewOptions = {}) {
    await new Auth0MfaChoicePageHelper({
      mfaGrantToken: this._qs.get('session_token'),
      mfaState: this._qs.get('state'),
      name: 'Auth0MfaChoicePageHelper',
      tenantOrDomain: this._tenant.id,
      whiteLabelOptions: this._whiteLabelOptions,
      appLoginUrl: this._appLoginUrl,
      clientId: this._clientId,
    }).render();

    return true;
  }
}

export default Auth0PreLoginHandlerMfaChoice;
